import { render } from "./RelatedServices.vue?vue&type=template&id=aec5c59a"
import script from "./RelatedServices.vue?vue&type=script&lang=js"
export * from "./RelatedServices.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__